import { Helmet } from "react-helmet-async";
import "./Careers.css";
import LandingNavbar from "../../components/LandingNavbar/LandingNavbar";
import TopBanner from "../../components/TopBanner/TopBanner";
import CareersBenefits from "./CareerBenefits/CareerBenefits";
import OpenRoles from "./OpenRoles/OpenRoles";
import GeneralApplication from "./GeneralApplications/GeneralApplications";
import Waitlist from "../../components/Waitlist/Waitlist";
import Footer from "../../components/Footer/Footer";


    const Careers = () => {
  return (
    <main className="careers-page">

      <Helmet>
        <title>Careers at Xyncely | Build Creator Marketing Technology</title>

        <meta
          name="description"
          content="Join Xyncely to build the campaign execution platform connecting brands, vendors, creators and internal teams. Explore current roles and opportunities."
        />

        <meta
          name="robots"
          content="index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1"
        />

        <link
          rel="canonical"
          href="https://xyncely.com/careers"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Xyncely" />
        <meta property="og:locale" content="en_IN" />

        <meta
          property="og:title"
          content="Careers at Xyncely | Build Creator Marketing Technology"
        />

        <meta
          property="og:description"
          content="Join Xyncely to build the campaign execution platform connecting brands, vendors, creators and internal teams. Explore current roles and opportunities."
        />

        <meta
          property="og:url"
          content="https://xyncely.com/careers"
        />

        <meta
          property="og:image"
          content="https://xyncely.com/assets/xyncely-og-1200x630.png"
        />

        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        <meta
          property="og:image:alt"
          content="Xyncely - The Command Center for Influencer Marketing"
        />

        {/* Twitter / X */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="Careers at Xyncely | Build Creator Marketing Technology"
        />

        <meta
          name="twitter:description"
          content="Join Xyncely to build the campaign execution platform connecting brands, vendors, creators and internal teams. Explore current roles and opportunities."
        />

        <meta
          name="twitter:image"
          content="https://xyncely.com/assets/xyncely-og-1200x630.png"
        />

        <meta
          name="twitter:image:alt"
          content="Xyncely - The Command Center for Influencer Marketing"
        />
      </Helmet>

      <TopBanner />
      <LandingNavbar />
        

      {/* Back to Home */}
      <div className="careers-page__back">
        <a href="/">
          ← <span>Back to Home</span>
        </a>
      </div>

      {/* Hero */}
      <section className="careers-hero">

        <div className="careers-hero__content">

          <div className="careers-hero__badge">
            WE ARE HIRING
          </div>

          <h1>
            Join the team shaping the future
            <br />
            of influencer marketing
          </h1>

          <p>
            Xyncely is building the first truly unified operating system for
            influencer performance and campaign intelligence. We are a
            fast-growing, product-led team dedicated to replacing spreadsheet
            chaos with clean, collaborative workflows.
          </p>

          <div className="careers-hero__actions">
            <a
              href="#open-roles"
              className="careers-hero__button careers-hero__button--primary"
            >
              View Open Roles
            </a>

            {/* <a
              href="#our-story"
              className="careers-hero__button careers-hero__button--secondary"
            >
              Read Our Story
            </a> */}
          </div>

        </div>

      </section>
<CareersBenefits/>
<OpenRoles/>
<GeneralApplication/>

<Waitlist
  eyebrow="JOIN THE TEAM"
  title="Help us reshape campaign intelligence"
  description="We're a small, ambitious team solving real problems for marketing operators. If that excites you, let's talk."
  buttonText="Join the Waitlist"
  showProgress={true}
  progressText="Remote-first · Competitive equity · High-impact work"
/>
<Footer/>
    </main>
  );
};

export default Careers;